let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8K0xc")).then(() => parcelRequire('aPQ9F'));